import { render, staticRenderFns } from "./mergerHeader.vue?vue&type=template&id=84c2d79c&scoped=true"
import script from "./mergerHeader.vue?vue&type=script&lang=js"
export * from "./mergerHeader.vue?vue&type=script&lang=js"
import style0 from "./mergerHeader.vue?vue&type=style&index=0&id=84c2d79c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c2d79c",
  null
  
)

export default component.exports